export default "__VITE_ASSET__BgNWTpf2__"